import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modalidade", "local", "tipo", "hora", "dataFinal", "horaFinal", "labelDataInicial", "labelHoraInicial"]

  static defaultHoras = ["00:00", "16:00"]

  connect() {
    this.toggle()
  }

  toggle({ resetHora = false } = {}) {
    const modalidade = this.modalidadeTarget.value
    const deveAtualizarHora = !this.horaTarget.value || (resetHora && this.constructor.defaultHoras.includes(this.horaTarget.value))

    if (modalidade === "videoconferencia") {
      this.labelDataInicialTarget.textContent = "Data da Sessão *"
      this.hide(this.dataFinalTarget)
      this.labelHoraInicialTarget.textContent = "Hora"
      if (deveAtualizarHora) this.horaTarget.value = "16:00"
      this.hide(this.horaFinalTarget)
      this.hide(this.localTarget)
      this.show(this.tipoTarget)
    } else if (modalidade === "virtual") {
      this.labelDataInicialTarget.textContent = "Data Inicial *"
      this.show(this.dataFinalTarget)
      this.labelHoraInicialTarget.textContent = "Hora Inicial *"
      if (deveAtualizarHora) this.horaTarget.value = "00:00"
      this.show(this.horaFinalTarget)
      this.hide(this.localTarget)
      this.hide(this.tipoTarget)
    } else {
      this.labelDataInicialTarget.textContent = "Data da Sessão *"
      this.hide(this.dataFinalTarget)
      this.labelHoraInicialTarget.textContent = "Hora"
      if (deveAtualizarHora) this.horaTarget.value = "16:00"
      this.hide(this.horaFinalTarget)
      this.show(this.localTarget)
      this.show(this.tipoTarget)
    }
  }

  modalidadeChanged() {
    this.toggle({ resetHora: true })
  }

  show(el) { el.style.display = "block" }
  hide(el) { el.style.display = "none" }
}
